import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import useBuildUpdatePlaidRows from './buildUpdatePlaidRows.helper';
import { useTranslation } from 'react-i18next';

const { Box, Button, Title, Table, TextField } = vp;

type UpdatePlaidProps = {
  onSubmit: (params: vp.SetPlaidCredentialsRequest) => void;
  defaultValues: vp.SetPlaidCredentialsRequest;
};
type FC = FunctionComponent<UpdatePlaidProps>;

const UpdatePlaid: FC = (props: UpdatePlaidProps) => {
  const { onSubmit, defaultValues } = props;
  const updatePlaidRows = useBuildUpdatePlaidRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Plaid.Update.Form' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={onSubmit}
      validationSchema={createdValidationSchema()}
      validateOnChange
      validateOnBlur
    >
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => {
        const updatePlaidTable: vp.TableProps = {
          name: 'update-plaid-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: updatePlaidRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="standard"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values[id]}
                error={errors[id] && touched[id] ? errors[id] : null}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box mb="md" jc="sb">
              <Title title={t('pageTitle')} />
            </Box>
            <Table {...updatePlaidTable} />
            <Box mt="md" jc="fe">
              <Button id="Plaid-review" type="submit" label={tGlobal('Buttons.review')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
  function createdValidationSchema() {
    return Yup.object().shape({
      PlaidClientID: Yup.string()
        .label(t('plaidClientId'))
        .required()
        .matches(/^.*\S+.*/, t('whiteSpaceValidation')),
      PlaidSecretKey: Yup.string()
        .label(t('plaidSecretKey'))
        .required()
        .matches(/^.*\S+.*/, t('whiteSpaceValidation')),
      PlaidUrl: Yup.string()
        .label(t('plaidUrl'))
        .required()
        .matches(/^.*\S+.*/, t('whiteSpaceValidation')),
    });
  }
};

export default UpdatePlaid;
